import React, { useState } from "react";
import {
  BasePageLayout,
  BaseBox,
  BaseTypography,
  BaseButton,
  BaseTextField,
  BaseCheckbox,
} from "../../../Common/UI/exports";
import { deleteTFStateLocks } from "../../../APIs/DynamoDB";

function IacTfStateUnlock() {
  const [serviceName, setServiceName] = useState("");
  const [unlockState, setUnlockState] = useState(false);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setResponse(null);
    try {
      const dryRun = !unlockState;
      const result = await deleteTFStateLocks(serviceName, dryRun);

      setResponse({
        serviceName,
        unlockState,
        dryRun,
        ...result,
      });
    } catch (err) {
      setResponse({
        error: err.message || "Unknown error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <BasePageLayout sidebarItems={[]}>
      <BaseBox
        sx={{
          height: "calc(100vh - 140px)",
          display: "flex",
          flexDirection: "column",
          maxWidth: "600px",
          mx: "auto",
          mt: 0,
          px: 2,
        }}
      >
        <BaseTypography sx={{ fontSize: "1.2rem", mb: 0, fontWeight: 600 }}>
          IaC / TF State Unlock
        </BaseTypography>

        <BaseBox
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 3 }}
        >
          {/* Service Name Field */}
          <BaseTextField
            label="Service Name"
            value={serviceName}
            onChange={(e) => setServiceName(e.target.value)}
            fullWidth
            placeholder="Enter service name"
          />

          {/* Unlock TF State Lock Checkbox */}
          <BaseCheckbox
            label="Unlock TF State Lock"
            checked={unlockState}
            onChange={() => setUnlockState(!unlockState)}
          />

          {/* Submit Button */}
          <BaseButton
            onClick={handleSubmit}
            sx={{ mt: 2, px: 4, py: 1.5 }}
            disabled={!serviceName || loading}
          >
            {loading ? "Processing..." : "Submit"}
          </BaseButton>
        </BaseBox>

        {/* Response */}
        <BaseBox
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 3 }}
        >
          <BaseTextField
            label="Response"
            value={response ? JSON.stringify(response, null, 2) : ""}
            fullWidth
            multiline
            rows={6}
          />
        </BaseBox>
      </BaseBox>
    </BasePageLayout>
  );
}

export default IacTfStateUnlock;
